import React, { useEffect, useState, useRef } from 'react';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux';
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import BlockIcon from '@material-ui/icons/Block';
import { IdentityActions, ShopActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h3": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 編集ボタン押下時の処理
     * 
     */
    const onEditClick = (e) => {
        props.onEdit(e.currentTarget.id);
    }

    /**
     * 
     * 無効化ボタン押下時の処理
     * 
     */
    const onDisableClick = () => {
        shopActions.setEnable(token, editing, false)
            .then(data => {
                notificationActions.showSuccess('無効にしました。');
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 有効化ボタン押下時の処理
     *
     */
    const onEnableClick = () => {
        shopActions.setEnable(token, editing, true)
            .then(data => {
                notificationActions.showSuccess('有効にしました。');
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    var editFlag = false;
    var disabledFlag = false;
    var disableButton = <div></div>; 

    if (permissions.fid5_3 != null && (permissions.fid5_3.value.value & 2) == 2) {
        // 店舗管理の変更権限が付与されている
        if (editing.is_disabled == false) {
            // 状態：有効

            editFlag = true;
            if (editing.can_disable == true) {
                // 無効化ボタンを有効
                disabledFlag = true;
            }
            disableButton =
                <Grid item xs={3} sm={6}>
                    <Button fullWidth variant="contained" size="medium"
                        disabled={!disabledFlag}
                        endIcon={<BlockIcon />}
                        onClick={onDisableClick}>「{editing.shop_name}」を無効化</Button>
                </Grid>;
        }
        else {
            // 状態：無効

            // 店舗を有効化可能
            disableButton =
                <Grid item xs={3} sm={6}>
                    <Button fullWidth variant="contained" size="medium"
                        endIcon={<BlockIcon />}
                        onClick={onEnableClick}>「{editing.shop_name}」を有効化</Button>
                </Grid>;
        }
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">店舗</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h3" variant="inherit">店舗情報</Typography>
                                <div>
                                    <Button fullWidth id="editButton" variant="contained" size="medium" color="primary" id="0"
                                        disabled={!editFlag}
                                        endIcon={<EditIcon />}
                                        onClick={(e) => onEditClick(e)}>編集</Button>
                                </div>
                            </div>

                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <table className={classes.table}>
                                <tbody>
                                    <tr><td><FormattedMessage id={"Shop.Name"} /></td><td>{editing.shop_name}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopFName"} /></td><td>{editing.shop_f_name}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopEName"} /></td><td>{editing.shop_e_name}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopPostalCd"} /></td><td>{editing.shop_postal_cd}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopAddress"} /></td><td>{editing.shop_adress}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopEAddress"} /></td><td>{editing.shop_e_adress}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.Latitude"} /></td><td>{editing.latitude}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.Longitude"} /></td><td>{editing.longitude}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopTel"} /></td><td>{editing.shop_tel}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopFax"} /></td><td>{editing.shop_fax}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.Merchant"} /></td><td>{editing.merchant_name}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopType"} /></td><td>{editing.shop_type == 1 ? '固定' : '可動式'}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.ShopCd3"} /></td><td>{editing.shop_cd_3}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.DealsInfo"} /></td><td>{editing.deals_info}</td></tr>
                                    <tr><td><FormattedMessage id={"Shop.Status"} /></td><td>{editing.is_disabled == false ? '有効' : '無効'}</td></tr>
                                </tbody>
                            </table>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" />
                                </Button>
                            </Grid>
                            {disableButton}
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )    
}

export default withStyles(style, { withTheme: true })(ShopDetail);